import { useMutation } from '@tanstack/react-query';

import { apiClient } from '@/lib/apiClient';
import type { MutationOptions } from '@/lib/reactQuery';
import type { NotificationCategoryType } from '@/types/notification';

export interface MarkNotificationAsReadResponse {
  message: string;
}

export const markAllNotificationsAsRead = async (categoryType?: NotificationCategoryType): Promise<MarkNotificationAsReadResponse> => {
  const response = await apiClient.post<MarkNotificationAsReadResponse>(`/v1/notifications/mark-as-read`, { categoryType });
  return response.data;
};

interface UseMarkAllNotificationsAsReadOptions {
  categoryType?: NotificationCategoryType;
  options?: MutationOptions<MarkNotificationAsReadResponse>;
}

export const useMarkAllNotificationsAsRead = ({ options, categoryType }: UseMarkAllNotificationsAsReadOptions) => {
  return useMutation({
    mutationKey: ['markAllNotificationsAsRead', categoryType],
    mutationFn: () => markAllNotificationsAsRead(categoryType),
    ...options,
  });
};
